/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

import { SERVICE_REQUEST_LABEL } from './entityLabels';

export const SERVICE_REQUEST_STATUSES = ['open', 'closed'];

export const SERVICE_REQUEST_STATUS_LABELS = {
  open: 'Open',
  closed: 'Closed',
};

export const SERVICE_REQUEST_MEDIA_FILE_TYPES = ['video', 'image', 'audio', 'session_recording'];

export const SERVICE_REQUEST_MEDIA_FILE_TYPE_LABELS = {
  video: 'Video',
  image: 'Image',
  audio: 'Audio',
  session_recording: 'Session Recording',
};

// Must match the backend's FindAllServiceRequestsDto sentinel used to filter
// for service requests with no assignedUserUid.
export const UNASSIGNED_FILTER_VALUE = 'unassigned';

export const SERVICE_REQUEST_EVENT_LABELS = {
  created: `${SERVICE_REQUEST_LABEL.singular} created`,
  status_changed: 'Status changed',
  type_changed: 'Type changed',
  hierarchy_changed: 'Options changed',
  customer_name_changed: 'Customer name changed',
  asset_identifier_changed: 'Asset identifier changed',
  equipment_identifier_changed: 'Equipment identifier changed',
  additional_details_changed: 'Additional details changed',
  media_added: 'Media added',
  media_removed: 'Media removed',
  note_added: 'Note added',
  assignee_changed: 'Assignee changed',
  public_link_generated: 'Public link generated',
  public_link_regenerated: 'Public link regenerated',
  public_link_expiry_updated: 'Public link expiry updated',
  public_link_revoked: 'Public link revoked',
  public_link_accessed: 'Public link accessed',
  live_session_joined: 'Live session joined',
};

// Mirrors SERVICE_REQUEST_NOTE_MAX_LENGTH in server/src/service-requests/constants.ts.
export const SERVICE_REQUEST_NOTE_MAX_LENGTH = 5000;
